import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanIsRoomPriceFree = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { isRoomPriceFree, hotelID } = viewModel;

	const activate = (input: true) => {
		if (input === true) {
			onSetViewModel([
				{
					key: "isRoomPriceFree",
					value: { isEdited: true, value: input },
				},
			]);
		}
	};

	const deactivate = (input: false) => {
		if (input === false) {
			onSetViewModel([
				{
					key: "isRoomPriceFree",
					value: { isEdited: false, value: input },
				},
			]);
		}
	};

	return {
		isRoomPriceFree,
		activate,
		deactivate,
		hotelID,
	};
};
